<template>
  <CSidebar
    style="font-family: 'Poppins'"
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand>
      <img
        custom-class-name="sidebar-brand-full"
        :src="AlgoLogo"
        class="img-fluid m-5"
        alt="algo"
      />
      <CIcon
        custom-class-name="sidebar-brand-narrow"
        :icon="sygnet"
        :height="35"
      />
    </CSidebarBrand>
    <AppSidebarNav />
    <!--CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleUnfoldable')"
    /-->

    <!-- MODAL CHANGE PASSWORD -->
    <Password />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import AlgoLogo from '@/assets/images/algo.png'
import { AppSidebarNav } from './AppSidebarNav'
import { sygnet } from '@/assets/brand/sygnet'
import Password from '../views/setting/Password.vue'

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
    Password,
  },
  setup() {
    const store = useStore()
    return {
      AlgoLogo,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
}
</script>
